import React from "react";

const PartnersTopNew = ({ partnersTopData = [] }) => {

    if (!partnersTopData.length) return null;

    return (
        <section className="py-[60px] mb-[60px] md:mb-[80px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <div className="grid gap-10 md:grid-cols-2 justify-center items-start border-b border-black pb-16">
                    {partnersTopData.map(({partners_top_select: {partners_top_status, partners_top_item}}, groupIndex) => (
                        <div className={"flex flex-col text-center justify-center toppartner-new-" + groupIndex} key={groupIndex}>
                            {/* Название */}
                            <h3 className="text-[#0b131c] font-normal mb-4 md:mb-8">{partners_top_status}</h3>
                            {/* Лого */}
                            <div className="flex items-center gap-8 lg:gap-12 justify-center">
                                {partners_top_item.map(({acf: {p_url, p_thumbnail, p_logo_width}}, partnerIndex) => (
                                    <a
                                        key={`${groupIndex}-${partnerIndex}`}
                                        href={p_url ? p_url : '/'}
                                        className={"flex-1 max-w-56 toppartner-count-" + partnerIndex}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img  src={p_thumbnail} alt={partners_top_status}className=" inline-block object-contain"/>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PartnersTopNew;